import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = { class: "w-full border rounded-lg border-neutral-100" }
const _hoisted_6 = { class: "relative overflow-auto" }
const _hoisted_7 = { class: "absolute left-0 top-0 h-full whitespace-nowrap position w-[181px] shadow-[2px_0_16px_0px_rgb(0,0,0,0.08)]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-[26px] bg-primary-100 text-sm font-semibold relative" }, "Settings", -1)
const _hoisted_9 = { class: "pl-[181px] min-h-[500px]" }
const _hoisted_10 = { class: "flex items-center justify-between p-6 border-b border-neutral-100" }
const _hoisted_11 = { class: "flex items-center space-x-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_14 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_15 = { class: "px-6 py-[18px] whitespace-nowrap text-sm text-gray-900" }
const _hoisted_16 = { class: "flex items-center space-x-2 justify-center mx-auto" }
const _hoisted_17 = { class: "w-full px-6 border-t py-7" }

import { ref, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ViewButton from "@/components/buttons/ViewButton.vue";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import RestoreButton from "@/components/buttons/RestoreButton.vue";
import DataTable from "../Components/DataTable.vue";
import SideTab from "../Components/SideTab.vue";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import TabComponent from "@/components/partials/TabComponent.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import PrimaryDiagnosisService from "@/classes/Settings/PrimaryDiagnosisService";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
/**
 * VARIABLES
 */
const tab = ref<any>(route.query.tab);
const items = ref<any>(null);
const filterSearch = ref<any>(route.query.query);
const page = ref<any>(route.query.page);
const lastPage = ref<any>(null);
const rows = ref<any>(route.query.rows || 5);
const numRows = computed(() => (rows.value ? rows.value + " Rows" : "All"));
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const primaryDiagnosisId = ref<number>(0);
const activityLogs = ref<any>({});

const tabs = ref<{ name: string; count: number; tab: string; href: string; allowed: boolean }[]>([
	{
		name: "All",
		count: 0,
		tab: "",
		href: "/settings/primary-diagnosis/index",
		allowed: true,
	},
	{
		name: "Archived",
		count: 0,
		tab: "archived",
		href: "/settings/primary-diagnosis/index?tab=archived",
		allowed: true,
	},
	{
		name: "Activity logs",
		count: 0,
		tab: "activity_logs",
		href: "/settings/primary-diagnosis/index?tab=activity_logs",
		allowed: true,
	},
]);

const headers: { text: string; haveSort?: boolean }[] = [{ text: "Primary Diagnosis" }, { text: "Date Updated" }];

/**
 * METHODS
 */
const getData = (search: any = null): void => {
	PrimaryDiagnosisService.index(
		pickBy({
			query: search ?? filterSearch.value,
			page: page.value,
			rows: rows.value,
			tab: tab.value,
		})
	)
		.then((response: any) => {
			items.value = response.data.items.data;
			activityLogs.value = response.data.items;
			page.value = response.data.items.current_page;
			lastPage.value = response.data.items.last_page;
			tabs.value[1].count = response.data.archivedItemsCount;
			tabs.value[2].count = response.data.activityLogsCount;
		})
		.catch((error: any) => {
			console.log(error);
		});
};

const reloadPage = async () => {
	return await router.push({
		path: "/settings/primary-diagnosis/index",
		query: pickBy({
			query: filterSearch.value,
			page: page.value,
			rows: rows.value,
			tab: tab.value,
		}),
	});
};

const applyFilters = (search: any = null) => {
	reloadPage().then(() => {
		getData(search);
	});
};

const changeRows = (row: any): void => {
	rows.value = row;
	applyFilters();
};

const paginate = (data: number): void => {
	page.value = data;
	applyFilters();
};

const updateTab = (currentTab: string) => {
	tab.value = currentTab;
	page.value = 1;
	applyFilters();
};

/**
 * MODALS
 */
const showDeleteModal = (item: any): void => {
	showConfirmation.value = true;
	primaryDiagnosisId.value = item.id;
};

const closeDeleteModal = (): void => {
	showSuccess.value = false;
};

const deleteRecord = (): void => {
	PrimaryDiagnosisService.delete({
		primaryDiagnosis: primaryDiagnosisId.value,
	})
		.then(() => {
			showSuccess.value = true;
			showConfirmation.value = false;
			applyFilters();
		})
		.catch((error) => console.log(error));
};

const showRestoreModal = (item: any): void => {
	showRestoreConfirmation.value = true;
	primaryDiagnosisId.value = item.id;
};

const closeRestoreModal = (): void => {
	showRestoreSuccess.value = false;
};

const restoreRecord = (): void => {
	PrimaryDiagnosisService.restore({
		primaryDiagnosis: primaryDiagnosisId.value,
	})
		.then(() => {
			showRestoreSuccess.value = true;
			showRestoreConfirmation.value = false;
			applyFilters();
		})
		.catch((error) => console.log(error));
};

/**
 * WATCHERS
 */
watch(
	filterSearch,
	throttle((val: string) => {
        page.value = 1;
		applyFilters(val);
	}, 1000)
);

watch(
    () => tab.value,
    throttle(() => {
        getData();
    }, 1000)
);


onMounted(() => {
	getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Settings",
            description: "View the relevant data and other details"
          }),
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/settings/primary-diagnosis/create')))
          }, [
            _createVNode(ButtonComponent, null, {
              default: _withCtx(() => [
                _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                _hoisted_3
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(SideTab, { primaryDiagnosisSelected: "" })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(TabComponent, {
                      tabs: tabs.value,
                      "onUpdate:tab": _cache[1] || (_cache[1] = (value) => updateTab(value))
                    }, null, 8, ["tabs"])
                  ])
                ]),
                (_unref(route).query.tab != 'activity_logs')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(DataTable, {
                        headers: headers,
                        "no-action": false,
                        count: items.value?.length,
                        "onUpdate:searchText": _cache[2] || (_cache[2] = (value) => (filterSearch.value = value)),
                        tableClass: "header-frm-table"
                      }, {
                        body: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                            return (_openBlock(), _createElementBlock("tr", { key: item }, [
                              _createElementVNode("td", _hoisted_13, _toDisplayString(item.name), 1),
                              _createElementVNode("td", _hoisted_14, _toDisplayString(item.updated_at_formatted), 1),
                              _createElementVNode("td", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                  (!tab.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(ViewButton, {
                                          onClick: ($event: any) => (
																	_unref(router).replace(
																		`/settings/primary-diagnosis/${item.id}/view`
																	)
																)
                                        }, null, 8, ["onClick"]),
                                        _createVNode(DeleteButton, {
                                          onClick: ($event: any) => (showDeleteModal(item))
                                        }, null, 8, ["onClick"])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (tab.value === 'archived')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (tab.value === 'archived')
                                          ? (_openBlock(), _createBlock(RestoreButton, {
                                              key: 0,
                                              onClick: ($event: any) => (showRestoreModal(item))
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["count"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(route).query.tab == 'activity_logs')
                  ? (_openBlock(), _createBlock(ActivityLogsTable, {
                      key: 1,
                      items: activityLogs.value
                    }, null, 8, ["items"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(MinifyPagination, {
                numRows: numRows.value,
                "onUpdate:rows": _cache[3] || (_cache[3] = (value) => changeRows(value)),
                "onUpdate:page": _cache[4] || (_cache[4] = (value) => paginate(value)),
                "current-page": page.value,
                "last-page": lastPage.value
              }, null, 8, ["numRows", "current-page", "last-page"])
            ]),
            _createVNode(ConfirmationModal, {
              typeTwo: true,
              show: showConfirmation.value,
              onCancel: _cache[5] || (_cache[5] = ($event: any) => (showConfirmation.value = false)),
              onConfirm: _cache[6] || (_cache[6] = ($event: any) => (deleteRecord())),
              "cancel-text": "Cancel",
              "action-text": "Confirm",
              title: "Delete Record",
              content: "Are you sure you wish to delete this record?"
            }, null, 8, ["show"]),
            _createVNode(SuccessModal, {
              show: showSuccess.value,
              onConfirm: _cache[7] || (_cache[7] = ($event: any) => (closeDeleteModal())),
              "action-text": "Close",
              title: "Record Deleted!",
              content: "Selected record has been successfully deleted!"
            }, null, 8, ["show"]),
            _createVNode(ConfirmationModal, {
              typeTwo: true,
              show: showRestoreConfirmation.value,
              onCancel: _cache[8] || (_cache[8] = ($event: any) => (showRestoreConfirmation.value = false)),
              onConfirm: _cache[9] || (_cache[9] = ($event: any) => (restoreRecord())),
              "cancel-text": "Cancel",
              "action-text": "Confirm",
              title: "Restore Record",
              content: "Are you sure you wish to restore this record?"
            }, null, 8, ["show"]),
            _createVNode(SuccessModal, {
              show: showRestoreSuccess.value,
              onConfirm: _cache[10] || (_cache[10] = ($event: any) => (closeRestoreModal())),
              "action-text": "Close",
              title: "Record Restored!",
              content: "Selected record has been successfully restored!"
            }, null, 8, ["show"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})